import { atom,DefaultValue, selector } from "recoil";

export const applicationState = atom({
    key: 'applicationManagement',
    default: {
        listApplication: [],
        application: {},
        documents: [],
        filterParams: {}
    }
});

export const appFilterParams = selector<any>({
    key: 'appFilterParams',
    get: ({ get }) => get(applicationState).filterParams,
    set: ({ set, get }, newValue) => {
        set(applicationState, {
            ...get(applicationState),
            filterParams: newValue instanceof DefaultValue ? get(applicationState).filterParams : newValue
        })
    }
});

export const listApplicationState = selector<any>({
    key: 'listApplication',
    get: ({ get }) => get(applicationState).listApplication,
    set: ({ set, get }, newValue) => {
        set(applicationState, {
            ...get(applicationState),
            listApplication: newValue instanceof DefaultValue ? get(applicationState).listApplication : newValue
        })
    }
});

export const applicationInfoState = selector<any>({
    key: 'applicationInfo',
    get: ({ get }) => get(applicationState).application,
    set: ({ set, get }, newValue) => {
        set(applicationState, {
            ...get(applicationState),
            application: newValue instanceof DefaultValue ? get(applicationState).application : newValue
        })
    }
});

export const documentsApplicationState = selector<any>({
    key: 'documentsApplication',
    get: ({ get }) => get(applicationState).documents,
    set: ({ set, get }, newValue) => {
        set(applicationState, {
            ...get(applicationState),
            documents: newValue instanceof DefaultValue ? get(applicationState).documents : newValue
        })
    }
});
